const About = () => {
  const aboutList = [
    {
      img: "/images/about1.png",
      txt1: "부산 경남 전지역",
      txt2: "출장비 없는 출장견적",
    },
    {
      img: "/images/about2.png",
      txt1: "고객만족 120% 달성!",
      txt2: "성실히 일하겠습니다",
    },
    {
      img: "/images/about3.png",
      txt1: "어떤 현장도 해결가능!",
      txt2: "어떤 현장도 자신있습니다",
    },
    {
      img: "/images/about4.png",
      txt1: "365일 24시간 출동",
      txt2: "언제든지 연락주세요",
    },
  ];
  return (
    <div
      id="about"
      className="relative w-full h-full px-[calc((100%-var(--container))/2)]  mx-auto py-14 lg:py-28 xl:pb-36"
    >
      <div id="title" className="relative w-full h-fit text-center mb-10">
        <div className="relative w-full h-fit">
          <h2 className="leading-none gmedium">
            몽땅이&nbsp;고객님께&nbsp;약속하는 4가지
          </h2>
          <h4 className="text-secondary gmedium">
            -&nbsp;MONG&nbsp;DDANG&nbsp;-
          </h4>
        </div>
        <p className="text-[#9e9e9e] text-lg lg:text-xl xl:text-2xl mt-3 xl:mt-5">
          부산&nbsp;·&nbsp;경남&nbsp;전지역&nbsp;고객님들이
          몽땅을&nbsp;선택해주시는&nbsp;이유!
        </p>
      </div>
      <div className="relative w-full h-fit max-w-[1600px] mx-auto grid grid-cols-2 lg:grid-cols-4 gap-5 lg:gap-8 pb-14 lg:pb-28 xl:pb-36 z-10">
        {aboutList.map((v, i) => (
          <div key={i} data-aos="fade-up" className="relative w-full h-fit">
            <div className="relative w-full h-fit overflow-hidden">
              <img
                className="!relative w-full h-full object-cover hover:scale-110 transition-transform duration-300"
                alt="img"
                src={v.img}
                width={414}
                height={506}
              />
            </div>
            <div className="absolute bottom-0 xl:top-full left-0 w-full h-fit bg-secondary text-white text-center py-3">
              <div className="leading-tight">
                <h3 className="!font-bold hidden lg:block whitespace-nowrap">
                  {v.txt1}
                </h3>
                <h4 className="font-normal hidden lg:block whitespace-nowrap">
                  {v.txt2}
                </h4>
                <p className="!font-bold block lg:hidden whitespace-nowrap">
                  {v.txt1}
                </p>
                <small className="font-normal block lg:hidden whitespace-nowrap">
                  {v.txt2}
                </small>
              </div>
            </div>
          </div>
        ))}
      </div>
      <div className=" absolute w-full lg:w-fit h-fit lg:right-[calc((100%-var(--container))/2)] bottom-12 lg:bottom-26 xl:bottom-32 z-0">
        <img
          className="max-w-screen-lg relative w-full h-auto object-contain"
          src="/images/aboutBg.png"
          alt="background"
          width={1693}
          height={178}
        />
      </div>
    </div>
  );
};

export default About;
